// The file structure: id: "text"
// for additional description there will be // over the id: "text"
// Strings with ${variable} in are generated, ${} meand variable require for proper message display

const SUCCESSES = {
  // CLASSROOMS SAGA
  handleAssignClassroomTest: "Test successfully assigned to class.",
  handleRescheduleClassLessons: "Lesson successfully rescheduled.",
  handleAddStudentToClass: "Student(s) successfully added to class.",
  handleAddInstructorToClass: `Successfully added Instructor to class`,
  handleUpdateClassroomSessionSaga: "Session successfully updated.",
  handleAssignWorksheetToClass: "Worksheet successfully assigned to class",
  handleAssignLessonsToClassSaga: "Lesson successfully assigned to class.",
  handleDeleteMultipleItemsFromClassSaga: "All items successfully deleted / unassigned.",
  handleApplyTemplateToStudent: "Session successfully applied to student.",
  handleApplyTemplateToClass: "Session successfully applied to student.",
  handleDeleteCourseTemplates: "Course template successfully deleted.",
  // GLOBAL SAGA
  handleSendWelcomeEmail: "Email successfully sent.",
  // INSTRUCTORS SAGA
  handleUpdateInstructor: `Instructor's data successfully updated.`,
  handleArchiveInstructorSaga: (archive) =>
    `Instructor successfully ${archive ? "" : "un"}archived.`,
  handleDeactivateInstructor: "Instructor successfully deactivated.",

  // LOCATIONS SAGA
  handleCreateLocation: `Successfully created location. Please use the search bar to find the new location.`,
  handleUpdateLocation: `Successfully Updated Location.`,
  // STUDENTS SAGA
  handleUpdateStudentReportSaga: "Parent report settings successfully updated.",
  handleUpdateStudent: `Successfully Updated Student.`,
  handleUpdateStudentSession: "Student's Session successfully updated.",
  handleUpdateStudentActivation: (activate: boolean) =>
    `Student successfully ${activate ? "activated" : "inactivated"}.`,
  handleRescheduleStudentLessons: "Lesson successfully rescheduled.",
  handleAssignWorksheet: "Worksheet successfully assigned to student.",
  handleRescheduleStudentWorksheets: "Worksheet successfully rescheduled.",
  handleUpdateWorksheetStatus: "Worksheet's status successfully updated.",
  handleUpdateWorksheetAnswers: "Worksheet's answers successfully updated.",
  handleAssignLessonsToStudentSaga: "Lesson successfully assigned to student.",
  handleCreateStudentSession: "Session successfully created.",
  handleDeleteMultipleItemsFromStudentSaga: "All items successfully deleted / unassigned.",
  handleRescheduleStudentTest: "Test successfully rescheduled.",
  handleChangePassword: "Password successfully changed!",
  // NEW - to be updated after Matt check the texts
  handleResetPassword: `Email successfully sent.`,
  handleResetLessons: "Lessons successfully reset.",
  handleResetWorksheets: "Worksheets successfully reset.",
  handleAssignSessionToClassroomSaga: "Session successfully assigned.",
  handleUnAssignTestFromClass: "Test unassigned successfully.",
  handleRemoveStudentFromClass: "Student successfully removed from a classroom.",
  handleUpdateStudentTest: "Test updated successfully.",
  handleRescheduleGroupStudentCalendarSaga: "All selected assignments rescheduled successfully.",
  handleEnrollStudentToCourse: (courseName: string) =>
    `Student successfully added to ${courseName} course.`,
  handleUpdateStudentBaselineScoresSaga: "Student's baseline scores updated successfully.",
  handleDeleteStudentTest: "Student's test successfully deleted.",
  handleCreateStudentRealTestSaga: "Student's test successfully created.",
  handleUpdateStudentRealTestSaga: "Student's test successfully updated.",
  handleAssignStudentTest: "Test successfully assigned to student.",
  handleSendReportSaga: "Student report successfully sent.",
  handleUpdateClassroomTest: "Classroom's test successfully updated.",
  handleDeleteClassroomSaga: "Classroom removed successfully.",
  handleCreateNewClassroomSaga: "Classroom created successfully.",
  handleUpdateClassArchived: "Classroom successfully archived.",
  handleStudentArchived: "Student successfully archived.",
  handleExcuseStudentLessonLatenessSaga: "Lesson(s) lateness status successfully updated.",
  handleMarkStudentLessonsFlagsReviewedSaga: "Lesson(s) flags successfully marked as reviewed.",
  handleManageStudentEnrollmentsSaga: "Success! Student’s enrollment status has been updated.",
  handleResetStudentTests: "All student's tests reset successfully.",
  handleAddNewStudent: "Student successfully created.",
  handleExcuseStudentWorksheetLateness: "Student worksheet(s) lateness excused successfully.",
  handleAddBulkAnswerToStudentTestSaga: "Section's answers successfully saved.",
  handleStudentTestSectionManagementSaga: "Test updated successfully.",
  handleMarkAllWorksheetFlagsReviewed: "Worksheet problems flags marked as reviewed successfully.",
  handleArchiveStudentsSaga: (isArchive: boolean) =>
    `Successfully ${isArchive ? "" : "un"}archived students.`,
  handleUpdateStudentAddress: "Student`s address successfully updated.",
  handleUpdateStudentAccount: "Student`s account updated successfully.",
  handleExcuseStudentTestLatenessSaga: "All tests successfully excused / unexcused.",
  handleSubmitLessonProblems: "Answers successfully saved.",
  handleUpdateInstructorAvatar: "Avatar successfully updated.",
  handleUpdateClassroomSaga: "Class succesfully updated.",
  handleRemoveInstructorFromClassroomSaga: "Instructor successfully removed from class.",
  handleRescheduleClassroomWorksheetsSaga: "Classroom's worksheets successfully rescheduled",
  handleUnAssignLessonFromClass: "Classroom's lessons unassigned successfully.",
  handleUpdateInstructorAddress: "Instructor's address successfully updated.",
  handleAddStudentToLocation: "Location successfully assigned.",
  handleUnassignLocationFromStudent: "Location successfully unassigned.",
  handleCreateInstructor: "Instructor successfully created.",
  handleUpdateInstructorManagement: "Instructor successfully updated.",
  handleAddInstructorToLocation: "Instructor successfully assigned to location.",
  handleCreateCourseTemplate: "Course Template created successfully.",
  handleUpdateCourseTemplate: "Course Template updated successfully.",
  handleRescheduleClassroomTests: "Tests successfully rescheduled",
  assignClassroomAssignmentToStudent: (type: string) =>
    `Students successfully assigned to this classroom's ${type}`,
  handleRevokeFullAccessSaga: "Revoke instructor full access successfully"
};

export default SUCCESSES;
